var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "language_menu_icon",
    transform: "translate(35 -170)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_",
    "data-name": "#",
    width: 24,
    height: 24,
    transform: "translate(-35 170)",
    fill: "#4b4f55",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "arabic",
    transform: "translate(-32 172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49360",
    "data-name": "Path 49360",
    d: "M31.974,9.406H30.5a.282.282,0,0,0-.2.083L28.391,11.4a.021.021,0,0,1-.037-.015V9.688a.282.282,0,0,0-.282-.282h-.3a.629.629,0,0,1-.628-.628V1.192a.629.629,0,0,1,.628-.628h7.585a.629.629,0,0,1,.628.628V5.4a.282.282,0,0,0,.564,0v-4.2A1.193,1.193,0,0,0,35.354,0H27.769a1.194,1.194,0,0,0-1.192,1.192V8.777a1.194,1.194,0,0,0,1.192,1.192h.021v1.413a.585.585,0,0,0,1,.414L30.617,9.97h1.357a.282.282,0,0,0,0-.564Z",
    transform: "translate(-26.577)",
    fill: "#d090ff",
    stroke: "#d090ff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49361",
    "data-name": "Path 49361",
    d: "M229.029,193.675h-7.585a1.194,1.194,0,0,0-1.192,1.192v7.585a1.194,1.194,0,0,0,1.192,1.192h4.738l1.827,1.827a.585.585,0,0,0,1-.414v-1.413h.021a1.194,1.194,0,0,0,1.192-1.192v-7.585A1.193,1.193,0,0,0,229.029,193.675Zm.628,8.777a.629.629,0,0,1-.628.628h-.3a.282.282,0,0,0-.282.282v1.695a.021.021,0,0,1-.037.015l-1.909-1.909a.282.282,0,0,0-.2-.083h-4.854a.629.629,0,0,1-.628-.628v-7.585a.629.629,0,0,1,.628-.628h7.585a.629.629,0,0,1,.628.628v7.585Z",
    transform: "translate(-212.221 -185.643)",
    fill: "#d090ff",
    stroke: "#d090ff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49362",
    "data-name": "Path 49362",
    d: "M99.4,56.689l0-.006a.313.313,0,0,0-.29-.195h0a.313.313,0,0,0-.29.2l0,.005-1.525,4a.222.222,0,1,0,.415.158L98.026,60h2.144l.343.868a.222.222,0,0,0,.415-.157Zm-1.2,2.863.908-2.383.9,2.383Z",
    transform: "translate(-94.165 -53.756)",
    fill: "#d090ff",
    stroke: "#d090ff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49363",
    "data-name": "Path 49363",
    d: "M303.376,246.076a1.232,1.232,0,0,1-.766.263,1.245,1.245,0,1,1,0-2.489h.559a.208.208,0,0,0,0-.415h-.67a.463.463,0,1,1,.345-.771.208.208,0,0,0,.309-.277.878.878,0,1,0-1.266,1.214,1.66,1.66,0,0,0,.724,3.154,1.644,1.644,0,0,0,1.022-.352.208.208,0,0,0-.256-.327Z",
    transform: "translate(-289.345 -231.348)",
    fill: "#d090ff",
    stroke: "#d090ff",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageMenuIcon);
export default __webpack_public_path__ + "static/media/language_menu_icon.2e4bdbd5180cfe9b58dc97c53819dd88.svg";
export { ForwardRef as ReactComponent };